export const mapSelectOptions = (schema) => {
  const values = schema.get('enum');
  const keys = schema.get('enumNames');
  return keys.zip(values);
};

export default {
  mapSelectOptions,
};



// WEBPACK FOOTER //
// ./src/features/test/TestForm/test-form-utils.js